<template>
  <div class="mr-2 ml-2 d-flex flex-column card-container">
    <span class="card-number" :style="{'color':textColor}">{{number}}</span>
    <div class="d-flex justify-content-center">
      <span class="card-subtitle">{{description}}</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    number: String,
    description: String,
    textColor: String
  },
  created () {
  }
}
</script>

<style>
.card-container {
  width: calc(100% / 9);
  border-top: 3px solid gray;
}
.card-subtitle {
  font-size: small;
  font-weight: normal;
}
.card-number {
  font-size: xx-large;
  line-height: 6rem;
}
.card-subtitle, .card-number {
  text-align: center;
}
.convex-border {
    position: relative
}
.convex-border:after {
    position: absolute;
    width: 100%;
    height: 4px;
    background: #000;
    border-radius: 100%;
    content: "";
    top: 0;
    left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardCard.vue